/**
 * Checks if the given email belongs to a SportNinja user
 * @param email - The email address to check
 * @returns true if the email ends with @sportninja.com
 */
export const isSportNinjaUser = (email?: string | null): boolean => {
  if (!email) return false
  return email.toLowerCase().endsWith('@sportninja.com')
}

export default isSportNinjaUser
